// A lightweight cross-component signal so an action that may have created a
// notification (e.g. scheduling or cancelling a job) can nudge the notification
// bell to refetch its unread count immediately, instead of waiting for the
// bell's periodic poll. The bell watches `refreshTick` and refetches on change.
export const state = {
  refreshTick: 0,
}

export const getters = {
  refreshTick(state) {
    return state.refreshTick
  },
}

export const mutations = {
  BUMP_REFRESH(state) {
    state.refreshTick += 1
  },
}

export const actions = {
  // Ask the notification bell to refresh now.
  refresh({ commit }) {
    commit('BUMP_REFRESH')
  },
}
